<main class="main-plain-centered">
  @if (isLoaded) {
    <div class="plain-content">
      <h1 class="sr-only" i18n="sr-only@@employment.teamOverview.title">Teamübersicht</h1>
      @if (visibleRelations.length > 0) {
        <div class="requests-area">
          <h2 class="section-heading" i18n="@@employment.teamOverview.requests">Anfragen</h2>
          <ol>
            @for (relation of visibleRelations; track relation) {
              <li class="request">
                <app-job-request [memberRelation]="relation" (removed)="onRequestRemoved($event)"></app-job-request>
              </li>
            }
          </ol>
        </div>
      }
      <div class="members-area">
        <h2 class="section-heading" i18n="@@employment.teamOverview.myTeam">Mein Team</h2>
        @if (employment.relationsInTeam.length === 0) {
          <app-empty-team (invitationSent)="addPlaceholder($event)"
          ></app-empty-team>
        }
        @if (employment.relationsInTeam.length > 0) {
          <ul class="members">
            @for (teamMember of employment.relationsInTeam; track teamMember) {
              <li class="member">
                <app-team-member [memberRelation]="teamMember"></app-team-member>
              </li>
            }
            <li class="member">
              <app-invitation (sent)="addPlaceholder($event)" [addPlaceholderToTeam]="true"></app-invitation>
            </li>
          </ul>
        }
      </div>
      @if (employment.invitees.length > 0) {
        <div class="invitee-area">
          <ul>
            @for (invitee of employment.invitees; track invitee) {
              <li class="invitee">
                <app-invitee-placeholder (removed)="clearPlaceholder($event)"
                [memberRelation]="invitee"></app-invitee-placeholder>
              </li>
            }
          </ul>
        </div>
      }
      @if (employment.relationsInTeam.length > 0) {
        <div class="footer-area">
          <img alt="" aria-hidden="true" class="footer-image" src="/assets/images/illustration-needs.svg">
          <app-message i18n="@@employment.teamOverview.haveIdeas">
                Wir arbeiten laufend daran, die CléA Assistenzplattform zu verbessern. Um Ihnen die Administration Ihrer
                persönlichen Assistentinnen und Assistenten zu erleichtern, planen wir die Einführung für Planung,
                Zeiterfassung inkl. Budgetplanung und Abrechnung als erweiterte Module der CléA Assistenzplattform.
                Haben Sie Ideen oder ein <a [href]="emailFeedbackPlatfrom">Feedback</a> , was wir sonst noch verbessern
                können?
            </app-message>
        </div>
      }
    </div>
  }
  @if (!isLoaded) {
    <div class="loading">
      <app-spinner></app-spinner>
    </div>
  }
</main>
